import React, { useEffect, useRef, useState } from 'react';
import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Paper,
  Radio,
  RadioGroup,
  TextField,
} from '@mui/material';

import { useNavigate, useParams } from 'react-router-dom';

import { GetClient, PostClientPaymentInfo } from '../services/httpServices';

import styled from '@emotion/styled';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));
const PaymentInfo = (props) => {
  const navigate = useNavigate();
  let { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [client, setClient] = useState({});
  const [paymentMethod, setPaymentMethod] = useState('Visa');

  const cardHolderNameRef = useRef('');
  const cardNumberRef = useRef('');

  const expDateRef = useRef('');
  const cvCodeRef = useRef('');

  const fetchClient = async (event) => {
    const client = await GetClient(props.id);
    setPaymentMethod(client?.clientPaymentInfos[0]?.mehtodOfPayment);

    setClient(client);
    setLoading(false);
  };
  useEffect(() => {
    fetchClient();
  }, []);
  // #endregion Refs

  const SaveUser = async (event) => {
    // setPosting(true);
    setLoading(true);
    event.preventDefault();
    //console.log('saveHit');
    const payload = {
      id: props.id,
      mehtodOfPayment: paymentMethod,
      cardHolderName: cardHolderNameRef.current.value,
      cardNumber: cardNumberRef.current.value,
      cvcode: cvCodeRef.current.value,
      expDate: expDateRef.current.value,
    };

    //console.log(payload);
    let response = await PostClientPaymentInfo(id, payload);
    //console.log('PostResponse:', response);

    if (response.status == 200) {
      setLoading(false);
      props.setMessage('Client saved successfully.');
      props.setSaved(true);
      props.setOpen(true);
      let clientSaved = client;
      clientSaved.clientPaymentInfos[0] = response.data;
      setClient(clientSaved);
      // setTimeout(() => {
      //   navigate(`/app/EditClient/${response.data.id}`);
      // }, 2000);
    } else {
      props.setMessage(response.data);
      props.setSaved(false);
      props.setOpen(true);
      setLoading(false);
      // setPosting(false);
    }
  };

  const handleChangePaymentMethod = (event) => {
    setPaymentMethod(event.target.value);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <form onSubmit={SaveUser}>
        {loading ? (
          <Grid display="flex" alignItems="center" justifyContent="center" height="20vh" container>
            <CircularProgress size={60} thickness={3} value={100} />
          </Grid>
        ) : (
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Box component={Paper} p={1}>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={4} md={12}>
                    <FormControl>
                      <FormLabel id="demo-controlled-radio-buttons-group">Payment Method:</FormLabel>
                      <RadioGroup
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="controlled-radio-buttons-group"
                        value={paymentMethod}
                        row
                        onChange={handleChangePaymentMethod}
                      >
                        <FormControlLabel value="Visa" control={<Radio />} label="Visa" />
                        <FormControlLabel value="MasterCard" control={<Radio />} label="MasterCard" />
                        <FormControlLabel value="AMEX" control={<Radio />} label="AMEX" />
                        <FormControlLabel value="Discover" control={<Radio />} label="Discover" />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={4} md={3}>
                    <TextField
                      label="Card Holder's Name"
                      required
                      variant="outlined"
                      fullWidth
                      size="small"
                      defaultValue={client?.clientPaymentInfos[0]?.cardHolderName}
                      inputRef={cardHolderNameRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={3}>
                    <TextField
                      label="Credit Card Number"
                      required
                      variant="outlined"
                      fullWidth
                      size="small"
                      defaultValue={client?.clientPaymentInfos[0]?.cardNumber}
                      inputRef={cardNumberRef}
                    />
                  </Grid>

                  <Grid item xs={12} sm={4} md={3}>
                    <TextField
                      label="Expiry Date"
                      type="date"
                      required
                      InputLabelProps={{ shrink: true }}
                      variant="outlined"
                      fullWidth
                      size="small"
                      defaultValue={client?.clientPaymentInfos[0]?.expDate?.split('T')[0]}
                      inputRef={expDateRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={3}>
                    <TextField
                      label="C.V Code"
                      required
                      variant="outlined"
                      fullWidth
                      size="small"
                      defaultValue={client?.clientPaymentInfos[0]?.cvcode}
                      inputRef={cvCodeRef}
                    />
                  </Grid>

                  <Grid item xs={12} sm={4} md={3}>
                    <Button type="submit" variant="contained">
                      Save
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>
        )}
      </form>
    </>
  );
};

export default PaymentInfo;
